/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { AddServiceTypes } from "shared/interface/types";

const initialState: { Service: AddServiceTypes; ServicePriceActivePlans: number[]; ServicePriceRateConfiguration: {}[] } = {
  Service: {
    id: null,
    name: "",
    description: "",
    serviceProviderId: "",
    takafulProviderId: "",
    serviceLimit: null,
    coverage: {
      id: null,
      value: ""
    },
    contribution: {
      id: null,
      value: ""
    },
    serviceProvider: {
      id: null,
      value: ""
    },
    takafulProvider: {
      id: null,
      companyName: ""
    }
  },
  ServicePriceActivePlans: [],
  ServicePriceRateConfiguration: []
};

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    AddService: (state, action) => {
      state.Service = action.payload;
    },
    DeleteService: state => {
      state.Service = initialState.Service;
    },
    UpdateServicePriceActivePlan: (state, action) => {
      state.ServicePriceActivePlans = action.payload;
    },
    UpdateServicePriceRateConfiguration: (state, action) => {
      state.ServicePriceRateConfiguration = action.payload;
    }
  }
});

export const { AddService, DeleteService, UpdateServicePriceActivePlan, UpdateServicePriceRateConfiguration } = serviceSlice.actions;
export default serviceSlice.reducer;

export const getService = (state: RootState) => state.service;
